<template>
	<v-dialog
			:value="isViewOffice"
			content-class="dialogWrapper"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View office</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldWrapper">
					<field
							:class-error="getError('name')"
							margin="0"
							width="100%"
							label="Office name"
							placeholder="Enter office name"
							:setInputValue="name"
							@updateInput="onInput($event, 'name')"
							is-required
					></field>

					<field
							:class-error="getError('location')"
							margin="0"
							width="100%"
							label="Location"
							placeholder="Enter location"
							:setInputValue="location"
							@updateInput="onInput($event, 'location')"
							is-required
					></field>

				</div>
				<div class="main">

				</div>
				<div class="footer">
					<custom-btn
							text="Save"
							@updateEvent="onSave"
							custom-class="apply"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'safe'}"
					></custom-btn>
					<custom-btn
							text="Close"
							@updateEvent="onClose"
							is-all-elements
							margin='0'
							:icon-attrs="{width: 20, height: 20, iconId: 'close'}"
					></custom-btn>
				</div>
			</div>
		</div>
		<preload v-if="isPreloader"></preload>

	</v-dialog>
</template>

<script>

import Vue from 'vue';

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from 'v-mask';
Vue.use(VueMask);

// validation
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { mapActions } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
export default {
	name: "ViewOffice",
	components: { Preload },
	mixins: [ validationMixin ],
	props: {
		dialogFlag: String,
		editOffice: Object,
	},
	validations: {
		name: { required },
		location: { required },
	},
	data: () => ({
		isViewOffice: true,
		name: null,
		id: null,
		location: null,
		isPreloader: false,
	}),

	methods: {
		...mapActions([ 'setAlert', 'onAccountOfficeSave', 'onAccountOfficeEdit' ]),

		onInput({ value }, key) {
			this[key] = value;
		},
		onTime(value, key) {
			this[key] = value;
		},

		async onSave() {
			this.isPreloader = true;

			this.$v.$touch();
			if (!this.$v.$error) {
				const { name, location, id } = this.$data;
				const sendInfo2 = { name, location };

				if (this.dialogFlag === 'add') {
					await this.onAccountOfficeSave({ sendInfo2, id });
				} else {
					await this.onAccountOfficeEdit({ sendInfo2, id });
				}
				this.$emit('updateClose');
				this.$emit('updateList');
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
			this.isPreloader = false;

		},

		onClose() {
			this.$emit('updateClose');
		},

		getError(key) {
			return this.$v && this.$v[key] && this.$v[key].$error;
		},
	},
	mounted() {
		this.isPreloader = true;

		if (this.dialogFlag === 'add') {
			this.name = null;
			this.id = null;
			this.location = null;
		} else {
			this.name = this.editOffice.name;
			this.id = this.editOffice.office_id;
			this.location = this.editOffice.location;
		}

		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">
@import "../ViewVersion/ViewVersion";
</style>
